module.exports = __webpack_public_path__ + "static/media/1_05.7a881ed0.png";